"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkInput = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var __1 = require("..");
var utils_1 = require("./utils");
var getCSSRules = function (_a) {
    var colors = _a.colors;
    return ({
        input: {
            backgroundColor: 'transparent',
            border: 'none',
            color: colors.Grey[700],
            padding: 0,
            '&:focus': {
                backgroundColor: 'transparent',
            },
        },
    });
};
var LinkInput = function (_a) {
    var editor = _a.editor, onToggleView = _a.onToggleView;
    var theme = (0, react_1.useTheme)();
    var styles = getCSSRules(theme);
    var _b = (0, react_2.useState)(editor.getAttributes('link').href || ''), link = _b[0], setLink = _b[1];
    var handleSubmit = function (e) {
        e.preventDefault();
        (0, utils_1.handleSetLink)(editor, link);
        onToggleView(false);
    };
    return ((0, jsx_runtime_1.jsx)("form", __assign({ onSubmit: handleSubmit }, { children: (0, jsx_runtime_1.jsx)(__1.Input, { css: (0, react_1.css)(styles.input), iconPosition: "right", icon: (0, jsx_runtime_1.jsx)(__1.Icon, { color: "Grey@0", style: {
                    pointerEvents: 'all',
                }, onClick: function () { return setLink(''); }, name: "remove", size: "md" }, void 0), value: link, onChange: function (e) { return setLink(e.target.value); }, placeholder: "Paste or type a link..." }, void 0) }), void 0));
};
exports.LinkInput = LinkInput;
exports.default = exports.LinkInput;
//# sourceMappingURL=LinkInput.js.map